import { useSelector } from "react-redux";
import { getAuthState } from "./authSlice";

const useAuthState = () => {
  return useSelector(getAuthState());
};

export { useAuthState };
